import { useEffect, useState } from "react";
import { Menu, X, MessageCircle } from "lucide-react";
import { DEFAULT_WA, scrollToId } from "../../lib/api";

const LINKS = [
  { id: "servicos", label: "Serviços" },
  { id: "ofertas", label: "Ofertas" },
  { id: "sobre", label: "Sobre" },
  { id: "contato", label: "Contato" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    setTimeout(() => scrollToId(id), 60);
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-ink/85 backdrop-blur-xl border-b border-line-dark"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 h-[72px] flex items-center justify-between">
        <button
          data-testid="navbar-logo-button"
          onClick={() => go("top")}
          className="flex items-center gap-3"
        >
          <img src="/brand/logo-white.png" alt="Contabiltec" className="h-10 w-auto" />
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="text-sm font-medium text-paper/70 hover:text-paper transition-colors uppercase tracking-[0.14em]"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            data-testid="navbar-whatsapp-cta"
            href={DEFAULT_WA}
            target="_blank"
            rel="noreferrer"
            className="hidden sm:inline-flex items-center gap-2 bg-crimson hover:bg-crimson-bright text-paper text-sm font-semibold px-5 py-2.5 rounded-full transition-all duration-300 hover:scale-[1.03]"
          >
            <MessageCircle size={16} />
            Fale conosco
          </a>
          <button
            data-testid="navbar-mobile-toggle"
            className="md:hidden text-paper p-2"
            onClick={() => setOpen(!open)}
            aria-label="Menu"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-ink/95 backdrop-blur-xl border-t border-line-dark">
          <div className="px-5 py-6 flex flex-col gap-5">
            {LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-mobile-link-${l.id}`}
                onClick={() => go(l.id)}
                className="text-left text-lg font-display font-semibold text-paper"
              >
                {l.label}
              </button>
            ))}
            <a
              data-testid="nav-mobile-whatsapp"
              href={DEFAULT_WA}
              target="_blank"
              rel="noreferrer"
              className="mt-2 inline-flex items-center justify-center gap-2 bg-crimson text-paper font-semibold px-5 py-3.5 rounded-full"
            >
              <MessageCircle size={18} /> Fale conosco no WhatsApp
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
